import React, { memo } from 'react';
import { FileType } from 'reactApp/types/FileType';
import { FileIcon } from 'reactApp/ui/FileIcon/FileIcon';

import styles from './DataListGalleryItemStub.css';

export const DataListGalleryItemStub = memo(function DataListGalleryItemStub() {
    return (
        <div className={styles.root}>
            <div className={styles.content}>
                <div className={styles.icon}>
                    <FileIcon size="l" type={FileType.IMAGE} />
                </div>
            </div>
        </div>
    );
});
